var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const GET_SET_ORDER_PAYMENTLINES = (orderId) => `/api/v2/order/${orderId}/paymentLines`;
const GET_SET_ORDER = 'api/v2/order';
const GET_SET_ORDER_CUSTOMERS_APP = 'api/v2/washdayapp/orders';
const PAY_AND_COLLECT = (sequence, storeId) => `/api/v2/order/${sequence}/${storeId}/pay-and-collect`;
const SEND_UNCOLLECTED_CUSTOMER_NOTIFICATION = (orderId) => `/api/v2/order/${orderId}/send-uncollected-customer-notification`;
const FAIL_SERVICE_ATTEMPT = (orderId) => `${GET_SET_ORDER}/${orderId}/service-attempts/fail`;
const STORE_TRANSFER = (orderId) => `${GET_SET_ORDER}/${orderId}/store-transfer`;
export const createPaymentLine = function (id, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.post(`${GET_SET_ORDER_PAYMENTLINES(id)}`, data, config);
        }
        catch (error) {
            console.error('Error fetching create:', error);
            throw error;
        }
    });
};
export const sendEmailReceipt = function (id) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.post(`${GET_SET_ORDER}/${id}/sendEmailReceipt`, {}, config);
        }
        catch (error) {
            console.error('Error fetching create:', error);
            throw error;
        }
    });
};
export const createOrderCustomersApp = function (data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.post(`${GET_SET_ORDER_CUSTOMERS_APP}`, data, config);
        }
        catch (error) {
            console.error('Error fetching createOrderCustomersApp:', error);
            throw error;
        }
    });
};
export const createOrderUsersApp = function (data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.post(`${GET_SET_ORDER}`, data, config);
        }
        catch (error) {
            console.error('Error fetching createOrderUsersApp:', error);
            throw error;
        }
    });
};
export const createReturnOrder = function (sourceOrderId, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.post(`${GET_SET_ORDER}/${sourceOrderId}/returns`, data, config);
        }
        catch (error) {
            console.error('Error creating return order:', error);
            throw error;
        }
    });
};
export const bulkCreatePaymentLines = function (storeId, body) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.post(`${GET_SET_ORDER}/${storeId}/bulkPaymentLines`, body, config);
        }
        catch (error) {
            console.error('Error fetching bulkCreatePaymentLines:', error);
            throw error;
        }
    });
};
export const createOrderEvidence = function (orderId, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${this.apiToken}`,
                    // 'Content-Type': 'multipart/form-data',
                    'Content-Type': false
                }
            };
            return yield this.axiosInstance.post(`${GET_SET_ORDER}/${orderId}/evidence`, data, config);
        }
        catch (error) {
            console.error('Error fetching createOrderEvidence:', error);
            throw error;
        }
    });
};
export const getRedeemPointsPreview = function (data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.post(`${GET_SET_ORDER}/redeemPointsPreview`, data, config);
        }
        catch (error) {
            console.error('Error fetching getRedeemPointsPreview:', error);
            throw error;
        }
    });
};
export const setOrderUncollected = function (data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.post(`${GET_SET_ORDER}/uncollected`, data, config);
        }
        catch (error) {
            console.error('Error fetching setOrderUncollected:', error);
            throw error;
        }
    });
};
export const payAndCollect = function (params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.post(PAY_AND_COLLECT(params.sequence, params.storeId), Object.assign(Object.assign(Object.assign({ orderId: params.orderId, paymentMethod: params.paymentMethod, cashierBoxId: params.cashierBoxId, amount: params.amount, paymentDate: params.paymentDate, collectedDateTime: params.collectedDateTime, collectWithAmountDue: params.collectWithAmountDue, pinUserId: params.pinUserId }, (params.pinValidationToken !== undefined ? { pinValidationToken: params.pinValidationToken } : {})), { attemptId: params.attemptId }), (params.expectedStatus !== undefined ? { expectedStatus: params.expectedStatus } : {})), config);
        }
        catch (error) {
            throw error;
        }
    });
};
export const sendOrderUncollectedCustomerNotification = function (orderId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.post(SEND_UNCOLLECTED_CUSTOMER_NOTIFICATION(orderId), {}, config);
        }
        catch (error) {
            console.error('Error fetching sendOrderUncollectedCustomerNotification:', error);
            throw error;
        }
    });
};
export const recordFailedServiceAttempt = function (orderId, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.post(FAIL_SERVICE_ATTEMPT(orderId), data, config);
        }
        catch (error) {
            console.error('Error fetching recordFailedServiceAttempt:', error);
            throw error;
        }
    });
};
export const previewStoreTransfer = function (orderId, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.post(`${STORE_TRANSFER(orderId)}/preview`, data, config);
        }
        catch (error) {
            console.error('Error previewing order store transfer:', error);
            throw error;
        }
    });
};
export const transferStore = function (orderId, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.post(STORE_TRANSFER(orderId), data, config);
        }
        catch (error) {
            console.error('Error transferring order to another store:', error);
            throw error;
        }
    });
};
export const resendNotification = function (orderId, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            return yield this.axiosInstance.post(`api/v2/order/${orderId}/notifications`, data, {
                headers: { Authorization: `Bearer ${this.apiToken}` },
            });
        }
        catch (error) {
            throw error;
        }
    });
};
